import { render, staticRenderFns } from "./TemplateListNormal.vue?vue&type=template&id=445fcdb3&scoped=true&"
import script from "./TemplateListNormal.vue?vue&type=script&lang=js&"
export * from "./TemplateListNormal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListNormal.vue?vue&type=style&index=0&id=445fcdb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445fcdb3",
  null
  
)

export default component.exports